import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../common/utils/utils';
import { constants } from '../../../common/constants/constants';
import { CurrencyValue } from '../../../common/currencyValue';

const ExpensesPdfRow = ({ expense }) => {
    const { t } = useTranslation();

    const date = BllinkUtils.BllinkTime.parseDate(expense.chargeDate);
    const amount = expense.amount;
    const vendor = expense.vendorName;
    const paymentType = expense.expenseTypeKey;
    const paymentTypeText = paymentType && t(`expenses.expenseTypes.${paymentType}`);
    const frequency = expense.isRecurring === 'yes' ? t('reports.recurring') : t('reports.oneTime');
    const isExpensePaymentSettled = expense.method !== constants.APIContract.paymentMethodsKeys.notSet;
    const paymentMethodKey = isExpensePaymentSettled ? expense.method : null;
    const paymentMethod = paymentMethodKey ? t(`buildings.${paymentMethodKey}`) : null;
    const chequeNumber = isExpensePaymentSettled ? expense?.expenseID : null;

    return (
        <div className='pdf-row'>
            <div className='expenses'>{date}</div>
            <div className='expenses'>
                <CurrencyValue currency={expense?.currency} notInCents={true}>{amount}</CurrencyValue>
            </div>
            <div className='expenses'>{vendor}</div>
            <div className='expenses'>{paymentTypeText}</div>
            <div className='expenses'>{frequency}</div>
            <div className='expenses'>{paymentMethod}</div>
            <div className='expenses'>{chequeNumber}</div>
        </div>
    )
}

export default ExpensesPdfRow;